// // src/RequireAuth.jsx
// import { Navigate, useLocation } from "react-router-dom";
// import { isLoggedIn } from "./auth";

// const RequireAuth = ({ children }) => {
//   const location = useLocation();

//   if (!isLoggedIn()) {
//     return <Navigate to="/login" state={{ from: location }} replace />;
//   }

//   return children;
// };

// export default RequireAuth;




import { Navigate, useLocation } from "react-router-dom";
import { isLoggedIn } from "./auth";

const RequireAuth = ({ children }) => {
  const location = useLocation();

  if (!isLoggedIn()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth;
